import React from 'react';
import { motion } from 'framer-motion';
import { Award, Clock, Shield } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-24 bg-offwhite relative z-10 overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-3">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-4">
            <div className="relative z-10 border-4 border-white shadow-2xl" data-id="element-5">
              <img src="https://cdn.magicpatterns.com/uploads/9akww1Up1LKsdE3KepnjME/155.jpg" alt="Offshore Platform Survey" className="w-full h-auto object-cover aspect-[4/3]" data-id="element-6" />
            </div>
            {/* Decorative background element */}
            <div className="absolute -bottom-6 -right-6 w-2/3 h-2/3 bg-navy/10 -z-0" data-id="element-7"></div>
            <div className="absolute -top-6 -left-6 w-1/3 h-1/3 bg-accent/10 -z-0" data-id="element-8"></div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-9">
            <span className="text-accent font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-10">
              About Diers and Stark
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy uppercase mb-6 leading-tight" data-id="element-11">
              Over a Century of Combined <br data-id="element-12" /> Marine Expertise
            </h2>

            <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-13">
              Led by Harry L. Stark, USCG (Ret.), NAMS-CMS, our team brings
              backgrounds in Coast Guard engineering, marine underwriting, and
              hands-on vessel operations.
            </p>
            <p className="text-gray-600 text-lg mb-10 leading-relaxed" data-id="element-14">
              Strategically located on the Gulf Coast with comprehensive general
              and marine liability insurance — giving us access to all
              refineries and shipyards.
            </p>

            <div className="grid grid-cols-3 gap-4 mb-10 border-t border-b border-gray-200 py-6" data-id="element-15">
              <div className="text-center px-2 border-r border-gray-200 last:border-0" data-id="element-16">
                <span className="block text-3xl font-heading font-bold text-navy mb-1" data-id="element-17">
                  100+
                </span>
                <span className="text-xs uppercase tracking-wider text-gray-500 font-medium" data-id="element-18">
                  Years Experience
                </span>
              </div>
              <div className="text-center px-2 border-r border-gray-200 last:border-0" data-id="element-19">
                <span className="block text-3xl font-heading font-bold text-navy mb-1" data-id="element-20">
                  NAMS
                </span>
                <span className="text-xs uppercase tracking-wider text-gray-500 font-medium" data-id="element-21">
                  CMS Certified
                </span>
              </div>
              <div className="text-center px-2" data-id="element-22">
                <span className="block text-3xl font-heading font-bold text-navy mb-1" data-id="element-23">
                  24yr
                </span>
                <span className="text-xs uppercase tracking-wider text-gray-500 font-medium" data-id="element-24">
                  USCG Service
                </span>
              </div>
            </div>

            <a href="#contact" className="inline-flex items-center justify-center px-8 py-3 border-2 border-navy text-base font-bold uppercase tracking-wider text-navy hover:bg-navy hover:text-white transition-all duration-300" data-id="element-25">
              Meet Our Team
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}